// extracted by mini-css-extract-plugin
module.exports = {"Card":"Card_Card__2KHN4","CardRow":"Card_CardRow__2nAf9","Value":"Card_Value__eNg7Q","Title":"Card_Title__1-Lrp","Description":"Card_Description__19Yv9","Icon":"Card_Icon__3etMg"};